export const CERTIFICATION_LEVEL: Record<string, string> = {
  "1": "PADI: Open Water Diver",
  "2": "PADI: Adventure Diver",
  "3": "PADI: Advanced Open Water Diver",
  "4": "PADI: Rescue Diver",
  "5": "PADI: Master Scuba Diver",
  "6": "PADI: Open Water Scuba Instructor",
  "7": "PADI: Specialty Instructor",
  "8": "PADI: Master Scuba Diver Trainer",
  "9": "PADI: IDC Staff Instructor",
  "10": "PADI: Master Instructor",
  "11": "PADI: Course Director",
  "12": "CMAS: Open Water Diver",
  "13": "CMAS: Club Diver",
  "14": "CMAS: Dive Leader",
  "15": "CMAS: Dive Supervisor",
  "16": "CMAS: National Diver",
  "17": "CMAS: Assistant Instructor",
  "18": "CMAS: Club Instructor",
  "19": "CMAS: Open Water Instructor",
  "20": "CMAS: Regional Instructor",
  "21": "CMAS: National Instructor",
  "22": "SSI: Open Water Diver",
  "23": "SSI: Advanced Training",
  "24": "SSI: Training Recognition",
  "25": "SSI: Specialist Diver",
  "26": "SSI: Advanced Open Water Diver",
  "27": "SSI: Master Diver",
  "28": "NAUI: Open Water Scuba Diver",
  "29": "NAUI: Advanced Scuba Diver",
  "30": "NAUI: Specialty Courses",
  "31": "NAUI: Master Scuba Diver",
  "32": "NAUI: Technical Courses",
  "33": "NAUI: Leadership Courses (AI, DM, SDI)",
};

/** Buddy invitation / join status on trip */
export const BUDDY_STATUS: Record<number, string> = {
  1: "Pending",
  2: "Accepted",
  3: "Rejected",
  4: "Removed",
};
